export const countryList = {
  title: "Liste des pays",
  line1:
    "Les niveaux globaux de le GDHM sont énumérées ci-dessous pour chaque pays participant. Les scores des pays sur les indicateurs " +
    "déterminent le niveau global de maturité de la santé numérique d'un pays.",
  line2:
    "Pour une ventilation plus détaillée pour chaque pays, veuillez consulter la page de chaque pays.",
  exportButtonText: "DONNÉES D'EXPORTATION POUR TOUS LES PAYS",
};
